import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TableModule } from 'primeng/table';
import { syncfusion_module } from './syncfusionmodule.module';
import { AccordionModule as ejsAccordionModule } from '@syncfusion/ej2-angular-navigations';
@NgModule({
  declarations: [ModalComponent,DatePickerComponent],
  imports: [CommonModule, DialogModule,AccordionModule,AccordionModule,TableModule,BsDatepickerModule.forRoot(),syncfusion_module,ejsAccordionModule,DatePickerModule],
  exports:[ModalComponent,AccordionModule,DatePickerComponent]
})
export class SharedModule {}
